module.exports = "/static/assets/a1a1c4e16826a2d41439a1c9a74a599c.png";